export enum VideoFormatEnum {
  VIDEO_8K = '8k',
  VIDEO_6_2K = '6.2k',
  VIDEO_C6K = 'c6k',
  VIDEO_6K = '6k',
  VIDEO_5_9K = '5.9K',
  VIDEO_5_8K = '5.8K',
  VIDEO_5_7K = '5.7K',
  VIDEO_4K = '4k',
  VIDEO_C4K = 'c4k',
  VIDEO_FULL_HD = 'full hd',
  VIDEO_HD = 'hd',
  VIDEO_NOT_SUPPORTED = 'non supportato',
}
